import gql from 'graphql-tag';
export default gql`
  mutation saveCalculatorOnlineAccount($calcLeadOpp: SaveCalcOnlineAccountInput) {
    saveCalculatorOnlineAccount(calcLeadOpp: $calcLeadOpp) {
      status
      message
      results {
        leadId
        vehicleApplicationId
        opportunityId
      }
    }
  }
`;
